var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 56,
    viewBox: "0 0 63 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4123 41.271L16.9065 30.6438C16.1939 28.4825 14.4552 26.8005 12.2442 26.1373L1.36026 22.8532C-0.146316 22.4018 -0.158521 20.3163 1.33584 19.8409L12.1709 16.401C14.3697 15.7019 16.084 13.9959 16.764 11.8265L20.1069 1.1474C20.567 -0.326822 22.6925 -0.342802 23.1771 1.12743L26.6829 11.7546C27.3955 13.912 29.1342 15.594 31.3452 16.2612L42.2291 19.5412C43.7357 19.9967 43.752 22.0782 42.2536 22.5536L31.4185 25.9935C29.2197 26.6926 27.5054 28.4025 26.8254 30.5719L23.4825 41.2471C23.0224 42.7253 20.8969 42.7413 20.4123 41.271Z",
    fill: "#FAFAFA",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8311 54.8416L49.1113 49.528C48.7617 48.4473 47.9088 47.6063 46.8241 47.2747L41.4848 45.6327C40.7458 45.4069 40.7398 44.3642 41.4728 44.1265L46.7882 42.4066C47.8668 42.057 48.7078 41.204 49.0414 40.1193L50.6813 34.7798C50.907 34.0426 51.9497 34.0347 52.1874 34.7698L53.9073 40.0834C54.2568 41.1621 55.1098 42.003 56.1944 42.3366L61.5337 43.9767C62.2728 44.2044 62.2808 45.2451 61.5457 45.4829L56.2304 47.2028C55.1517 47.5524 54.3108 48.4073 53.9772 49.492L52.3372 54.8296C52.1115 55.5687 51.0688 55.5767 50.8311 54.8416Z",
    fill: "#FAFAFA",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.ad7583746b067c774e6ab7927eb53f5c.svg";
export { ForwardRef as ReactComponent };